<template>
  <div class="page-intro" v-if="intro" :style="{'padding-top': webWithoutNavigation ? '42px' : 0}">
    <div class="intro-wrap">
      <img class="intro-img" :src="intro.image" alt="">
    </div>
    <a class="btn-intro" href="weixin://dl/">
      <img src="./images/btn-intro.jpg" alt="">
    </a>
  </div>
</template>

<script>
import storeMixin from '../mixins/store'
export default {
  name: 'course-intro',
  props: ['id'],
  mixins: [storeMixin],
  data () {
    return {
      intro: null
    }
  },
  watch: {
    loginCount: {
      immediate: true,
      handler: function (v) {
        if (v > 0) {
          this.getCourseIntro()
        }
      }
    }
  },
  methods: {
    async getCourseIntro () {
      try {
        const {data: {code, data, message}} = await this.$rootApi.api(['courseIntro'], {
          data: {id: this.id}
        })
        if (code === 0) {
          this.intro = data
          this.SET_PAGE_TITLE(data.name)
        } else {
          throw message
        }
      } catch (e) {
        this.$toast(e.message || e)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.btn-intro
  > img
    display block
    width 100%
    height 100%
.intro-wrap
  flex 1
  overflow auto
  overflow-scrolling touch
  > img
    display block
    width 100%
.page-intro
  position absolute
  width 100%
  height 100%
  display flex
  flex-direction column
</style>
